document.addEventListener("DOMContentLoaded", () => {
	const modal = document.getElementById("modal");
	const modalImage = document.getElementById("modal-image");
	const modalRollover = document.getElementById("modal-rollover");
	const modalTitle = document.getElementById("modal-title");
	const modalDescription = document.getElementById("modal-description");
	const closeModalButton = document.getElementById("close-modal");
	const modalDetails = document.querySelector(".modal-details");

	document.querySelectorAll(".grid__item").forEach((item) => {
		item.addEventListener("click", () => {
			const imageSrc = item.querySelector("img").src;
			const rolloverSrc = item.querySelector("img + img")?.src || false;
			const title = item.getAttribute("data-title") || "";
			const description = item.getAttribute("data-description") || "";

			modalImage.src = imageSrc;
			modalRollover.src = rolloverSrc ? rolloverSrc : "";

			modalImage.alt = title;

			modalTitle.textContent = title;
			modalDescription.textContent = description;

			if (!title.trim() && !description.trim()) {
				modalDetails.style.display = "none";
				modalImage.parentElement.style.flex = "100%";
			} else {
				modalDetails.style.display = "block";
				modalImage.parentElement.style.flex = "60%";
			}

			modal.classList.remove("hidden");
		});
	});

	closeModalButton.addEventListener("click", () => {
		modal.classList.add("hidden");
	});

	modal.addEventListener("click", (event) => {
		if (event.target === modal) {
			modal.classList.add("hidden");
		}
	});
});